import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IBox } from '../interfaces';
import { BoxMapper } from '../mappers';

export type IGetBoxesRepoResponse = IRepoResponse<200, { data: IBox[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetBoxesRepo = IRepo<[any], IGetBoxesRepoResponse>;

export const GetBoxesRepoType = Symbol.for('GetBoxesRepo');

@bind(GetBoxesRepoType)
export class GetBoxesRepo implements IGetBoxesRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/containers', query) });

      if (result.status === 200) {
        const data: IBox[] = result.data.data.map((user) => BoxMapper.toDomain(user));
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: {
            data,
            total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
